/**
 * Layout constants shared across the app (e.g. Navigation, Personalize).
 * Single source of truth for heights used in positioning and centering.
 */

/** Desktop nav bar height in rem (used by Navigation component). */
export const NAV_BAR_HEIGHT_REM = 4.5625

/** Desktop nav bar height in px (for calc() in CSS, e.g. first-section margin). */
export const NAV_BAR_HEIGHT_PX = Math.round(NAV_BAR_HEIGHT_REM * 16)

/** scroll-margin-bottom value so section headers center in visible area when scrolling to them. */
export const SCROLL_MARGIN_BOTTOM_HEADER = `-${NAV_BAR_HEIGHT_PX}px`

/** Viewport vertical center. Used for review section target (last section never crosses line). */
export const getViewportHalfHeight = (): number =>
    typeof window !== 'undefined' ? window.innerHeight / 2 : 0

/**
 * Y-coordinate (from viewport top) that triggers active stepper.
 * When a section's header center (headerTop + headerHeight/2) is closest to this line, that section is active.
 * Matches stepper click: center of visible area below navbar = navBar + (viewportHeight - navBar) / 2.
 * ~518px with viewport 963.
 */
export const getScrollTargetCenterY = (): number =>
    typeof window !== 'undefined'
        ? NAV_BAR_HEIGHT_PX + (window.innerHeight - NAV_BAR_HEIGHT_PX) / 2
        : 0
